import React, { Component } from 'react';

import './MapInfoWindow.css';

class InfoWindowContent extends Component {
  constructor(...args) {
    super(...args);
    this.prevSlideHandler = this.changeSlide.bind(this, -1);
    this.nextSlideHandler = this.changeSlide.bind(this, 1);
    this.state = {
      activeIndex: 0
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.company.id !== nextProps.company.id) {
      this.setState({ activeIndex: 0 });
    }
  }

  changeSlide(increment, event) {
    if (event && typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }

    const max = this.props.company.bikes.length - 1;
    let activeIndex = this.state.activeIndex + increment;

    if (activeIndex > max) {
      activeIndex = max;
    }

    if (activeIndex < 0) {
      activeIndex = 0;
    }

    this.setState({ activeIndex });
  }

  render() {
    return (
      <div className="custom-info-window">
        <span
          className="map-company-close"
          onClick={this.props.onClose}
        />

        <div className="map-bike-slider">
          <ul
            className="map-bike-slider-list"
            style={{ transform: `translateX(-${this.state.activeIndex * 100}%)` }}
          >
            {this.props.company.bikes.map(bike => (
              <li
                key={bike.id}
                className="map-bike-slide"
                onClick={this.props.onSelect.bind(this, bike)}
              >
                <div
                  className="map-bike-image"
                  style={{ backgroundImage: bike.photos && bike.photos[0] ? `url(${bike.photos[0].image})` : null }}
                />

                <div className="map-bike-info">
                  <span className="map-bike-name">
                    {bike.name}
                  </span>

                  <span className="map-bike-price">
                    {bike.displayPrice}
                  </span>
                </div>
              </li>
            ))}
          </ul>

          {(this.state.activeIndex > 0) && (
            <span
              className="map-bike-slider-prev"
              onClick={this.prevSlideHandler}
            />
          )}

          {(this.state.activeIndex < this.props.company.bikes.length - 1) && (
            <span
              className="map-bike-slider-next"
              onClick={this.nextSlideHandler}
            />
          )}
        </div>
      </div>
    );
  }
}

export default InfoWindowContent;



// WEBPACK FOOTER //
// ./src/components/SearchPage/SearchMap/MapInfoWindow.js